import { useEffect, useState } from "react";
import { Sections } from "../../../util/types";
import { IInformacionGeneral } from "../../../interfaces/InformacionGeneral";
import { getInformacionGeneralRegional } from "../../../api/informacionGeneral";
import { useTranslation } from "react-i18next";
import { DataSectionLoader3Rows } from "../../Home/Loaders/DataSectionLoader";
import InformationCard from "../../../components/RepresentationLayout/InformationCard";
import iniciativas from "../../../assets/iconos/iniciativas.svg"
import avance from "../../../assets/iconos/avance.svg"
import productores from "../../../assets/iconos/productores.svg"
import logros from "../../../assets/iconos/logros.svg"
import resultados from "../../../assets/iconos/resultados.svg"

const Data: React.FC<{ 
    refreshActiveSection: (section: Sections) => void,
    activeSection?:Sections
 }> = ({ refreshActiveSection, activeSection }) => {

    const { t } = useTranslation("translation", {
        keyPrefix: "home.data_section",
    });
    const [infoGeneral, setInfoGeneral] = useState<IInformacionGeneral>()

    const loadData = () => {
        setInfoGeneral(undefined)

        getInformacionGeneralRegional()
            .then((response) => {
                setInfoGeneral(response);
                return;
            });
    }

    useEffect(() => {
        loadData()
        return () => {
            //Reinicio los estados
            setInfoGeneral(undefined);
        }
    }, []);

    if (!infoGeneral) {
        return (
            <div className="col-md-12">
                <DataSectionLoader3Rows />
            </div>
        );
    }

    return (
        <div className="col-md-12">
            <div className="row">
                <div className="col-lg col-sm-12">
                    <InformationCard
                        icon={iniciativas}
                        value={infoGeneral.cantidadProyectos}
                        text={t("iniciativas")}
                        activeSection={activeSection}
                        section="initiatives"
                        onClick={() => {
                            refreshActiveSection("initiatives")
                        }} />
                </div>
                <div className="col-lg col-sm-12">
                    <InformationCard
                        icon={resultados}
                        value={infoGeneral?.cantidadResultados}
                        text={t("resultados")}
                    />
                </div>
                <div className="col-lg col-sm-12">
                    <InformationCard
                        icon={avance}
                        value={Math.round(infoGeneral?.porcentajeAvance!)}
                        text={t("avance")}
                        suffix="%"
                    />
                </div>
                <div className="col-lg col-sm-12">
                    <InformationCard
                        icon={productores}
                        value={infoGeneral?.cantidadAgricultores}
                        text={t("productores")}
                        headlineSize="h4"
                    />
                </div>
                <div className="col-lg col-sm-12">
                    <InformationCard
                        icon={logros}
                        value={infoGeneral.cantidadLogros ? infoGeneral.cantidadLogros : 0}
                        text={t("logros")}
                        activeSection={activeSection}
                        section="logros"
                        onClick={() => {
                            refreshActiveSection("logros")
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default Data